module.exports = __webpack_public_path__ + "img/1.fb5b58a3.png";